import styled from 'styled-components'

export const CardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.xs}rem;
`

export const StyledCard = styled.div<{ $isActive: boolean }>`
  display: flex;
  flex-direction: row;
  padding: ${({ theme }) => theme.spacing.md}rem;
  border: 2px solid
    ${({ $isActive, theme }) => ($isActive ? theme.colors.primary : theme.colors.neutralGray)};
  background: ${({ $isActive, theme }) => ($isActive ? theme.colors.primary + '09' : 'white')};
  border-radius: ${({ theme }) => theme.borderRadius.md}rem;
  flex: 1;
  color: ${({ theme }) => theme.colors.metalGray};
  font-size: ${({ theme }) => theme.fontSize.md}rem;
  gap: ${({ theme }) => theme.spacing.xxs}rem;

  & > * {
    margin: 0;
  }
`

export const IconCol = styled.div<{ $isActive: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 2.4rem;
  min-width: 2.4rem;
  height: 2.4rem;
  min-height: 2.4rem;
  margin-right: ${({ theme }) => theme.spacing.sm}rem;
  background: ${({ theme, $isActive }) =>
    $isActive ? theme.colors.primary + '22' : theme.colors.defaultHover};
  border-radius: 100px;

  & > * {
    width: 1.5rem;
    height: 1.5rem;
    color: ${({ theme, $isActive }) => ($isActive ? theme.colors.primary : theme.colors.metalGray)};
  }
`

export const ContentCol = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.xxs}rem;
`

export const HeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  h4 {
    margin: 0;
    font-size: ${({ theme }) => theme.fontSize.md}rem;
    color: ${({ theme }) => theme.colors.neutralBlack};
  }
`

export const PriceRow = styled.div`
  margin-top: ${({ theme }) => theme.spacing.xxs}rem;
`

export const ActiveLabel = styled.div`
  font-weight: bold;
  color: ${({ theme }) => theme.colors.neutralWhite};
  background: ${({ theme }) => theme.colors.primary};
  font-size: ${({ theme }) => theme.fontSize.sm}rem;
  padding: ${({ theme }) => theme.spacing.xxs}rem ${({ theme }) => theme.spacing.xs}rem;
  border-radius: ${({ theme }) => theme.borderRadius.md}rem;
`

export const UnstyledButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  width: 100%;
  text-align: left;

  &:focus {
    outline: none;
  }
`

export const ButtonRow = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: ${({ theme }) => theme.spacing.xs}rem;
`
